import { SITE } from '../config/site';

export function FoxMark({ className = '' }) {
  return (
    <svg className={`fox-mark ${className}`.trim()} viewBox="10 7 44 50" aria-hidden="true" focusable="false">
      <path className="fox-mark__head" d="M12 9 26 21h12L52 9v22L32 55 12 31Z" />
      <path className="fox-mark__light" d="M15.5 15.5 23 22.5 15.5 25Zm33 0L41 22.5l7.5 2.5ZM16 32l16 6 16-6-16 18Z" />
      <path className="fox-mark__dark" d="M29 45.5h6l-3 4Zm-8-14 6-1-2.5 3Zm22 0-6-1 2.5 3Z" />
    </svg>
  );
}

function BrandMark({ className = '' }) {
  return (
    <span className={`brand ${className}`.trim()}>
      <span className="sr-only">{SITE.name}</span>
      <FoxMark className="brand__mark" />
      <span className="brand__text" aria-hidden="true">
        <span className="brand__name">Fox<em>Inmo</em></span>
        <span className="brand__sub">Propiedades</span>
      </span>
    </span>
  );
}

export default BrandMark;
